import { render, staticRenderFns } from "./ManejoAcuerdos.vue?vue&type=template&id=f435824c"
import script from "./ManejoAcuerdos.vue?vue&type=script&lang=js"
export * from "./ManejoAcuerdos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports